/**
 * Created by mac on 2017/6/16.
 */
const tmp = {
  state: {
    r_param: null,
    gurl: null
  },
  mutations: {
    SET_PARAM: (state, obj) => {
      state.r_param = obj
    },
    SET_GURL: (state, obj) => {
      state.gurl = obj
    }
  },
  actions: {
    setParam({commit}, obj) {
      commit('SET_PARAM',obj)
    },
    setGurl({commit}, obj) {
      commit('SET_GURL',obj)
    }
  }
}

export default tmp



// WEBPACK FOOTER //
// ./src/vuex/modules/tmp.js